import Flex from '@talkdesk/cobalt-react-flex'
import Link from '@talkdesk/cobalt-react-link'
import Image from '@talkdesk/cobalt-react-image'
import Box from '@talkdesk/cobalt-react-box'
import { LOGO_ALTERNATE_TEXT } from '../../constants/ui.labels'
import { ROOT } from '../../constants/accountRecoveryLinks'
import { TALKDESK_LOGO } from '../../constants/accountRecoveryImages'
import styles from './AccountRecoveryNavbar.module.css'

const AccountRecoveryNavbar = ({ actionElement }) => {
  return (
    <Flex
      as='nav'
      width='100%'
      paddingY='2'
      paddingInlineStart='6'
      paddingInlineEnd='6'
      className={styles.navbar}
    >
      <Flex grow>
        <Box>
          <Link href={ROOT}>
            <Image
              src={TALKDESK_LOGO}
              alt={LOGO_ALTERNATE_TEXT}
              width={100}
              height={36}
            />
          </Link>
        </Box>
      </Flex>
      {actionElement && (
        <Flex>
          <Box>{actionElement}</Box>
        </Flex>
      )}
    </Flex>
  )
}

export default AccountRecoveryNavbar
